import { createContext, useContext, useState } from "react";

const LayoutContext = createContext();

export const useLayout = () => useContext(LayoutContext);

export const LayoutProvider = ({ children }) => {
  const [isNavPinned, setIsNavPinned] = useState(false);

  const togglePin = () => {
    setIsNavPinned((prev) => !prev);
  };

  const value = {
    isNavPinned,
    togglePin,
  };

  return (
    <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
  );
};
